<template>
  <div class="modal fade" tabindex="-1" :id="id">
    <div class="modal-dialog modal-lg">
      <form @submit.prevent="createPersonalDiscussion" class="form">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">{{ $t('chat.create_discussion') }}</h5>
            <div class="btn btn-icon btn-sm btn-active-light-primary ms-2" data-bs-dismiss="modal" aria-label="Close">
                <span class="svg-icon svg-icon-1">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <rect opacity="0.5" x="6" y="17.3137" width="16" height="2" rx="1" transform="rotate(-45 6 17.3137)"
                        fill="currentColor"/>
                  <rect x="7.41422" y="6" width="16" height="2" rx="1" transform="rotate(45 7.41422 6)"
                        fill="currentColor"/>
                </svg>
              </span>
            </div>
          </div>
          <div class="modal-body">
            <RequiredText />
            <div class="row">
              <div class="col-md-12">
                <Select2
                    :parent-id="'#'+id"
                    containerClass="col-12 mt-auto mb-5"
                    :name="`${id}-gender`"
                    type="text"
                    :label="$t('chat.select_member')"
                    labelClass="form-label fs-6 text-black"
                    selectClass="form-select form-select-solid"
                    :isRequired="true" size="lg"
                    :placeholder="$t('chat.select_member')"
                    @update:modelValue="handleUserClass"
                    v-model="formData.user_id"
                    :multiple="false">
                  <option v-for="user in users" :value="user.id">
                    {{ user.fullname }}
                    <span class="text-primary" v-if="user.is_customer"> client </span>
                  </option>
                </Select2>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <Button type="cancel" id="cancel_btn" btn-class="btn-sm me-3" size="7px 30px" btn-text="button.cancel" @click="closeModal"></Button>
            <Button btn-class="btn-sm me-3" type="submit" id="submit_btn" btn-text="button.save" size="7px 30px" :is-loading="processing"></Button>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script setup>
import {ref, defineEmits, defineProps, computed, onMounted} from "vue";
import Select2 from "@/components/Select2.vue";
import {useStore} from "vuex";
import RequiredText from "@/components/RequiredText"
import Button from "@/components/Button"
import {useRouter} from "vue-router";

const store = useStore()
const router = useRouter()
const emits = defineEmits(['afterUpdate', 'afterCreate'])
const props = defineProps({
  id: { type: String, required: true},
  moduleClass: {type: String, default: ''},
  moduleId: {type: String, default: ''},
})

const processing = ref(false)
const formData = ref({
  'discussion_type': 'personal', //personal or group
  'user_id': null,
  'user_type': null,
})

const users = computed(() => store.getters['chat/getUsers'])

function closeModal(){
  $('#'+props.id).modal('toggle')
}

onMounted(() => {
  loadData()
})

function loadData() {
  Promise.all([
    store.dispatch('chat/loadAllUsers', { module_id: props.moduleId, module_class: props.moduleClass }),
  ])
}

function resetForm() {
  formData.value = {
    'discussion_type': 'personal', //personal or group
    'user_id': null,
    'user_type': null,
  }
}

async function createPersonalDiscussion() {
  processing.value = true
  try {



    let response = await store.dispatch('chat/createPersonalDiscussion', {
      module_id: props.moduleId,
      module_class: props.moduleClass,
      ...formData.value
    })

    // router.push({name: 'chats-conversation-messages', params: {
    //   id: response.data.data.id
    // }})

    closeModal()
    resetForm()

    processing.value = false

    window.toastr['success'](i18n.global.t('chat.discussion_created_successfully'))
  }catch (e) {
    processing.value = false
  }
}

function handleUserClass(value) {
  formData.value.user_type = users.value.find(el => el.id === value)?.model
}

</script>